<template>
  <div class="home center-all">
    <div class="container" v-if="loaded">
      <div class="card card-add card-other" @click="postSection">
        <i class="fa-solid fa-plus" style="color: var(--main-color); font-size: 35px;"></i>
        <p>Crear Sección</p>
      </div>
      <div class="card" v-for="(item, index) in sections" :key="index">
        <div class="separate">
          <p class="card-title">{{ item.sectionCode }}</p>
          <i class="fa-solid fa-copy icon" @click="copyText(index)"></i>
        </div>
        <div class="separate2">
          <p class="card-content card-content-other" v-if="item.name == null || item.name == ''">Sin Nombrar</p>
          <p class="card-content" v-else>{{ item.name }}</p>
          <button class="button" @click="goToRoute('section/' + item.id)">Ver sección</button>
        </div>
      </div>
    </div>
    <div class="container" v-else>
      <img src="../assets/loading.gif" alt="Loading" style="height: 200px; height: 200px; padding: 10px;">
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "HomeView",
  data() {
    return {
      sections: [],
      sectionData: {
        name: null,
        visible: false,
      },
      loaded: false,
    };
  },
  mounted() {
    this.getSections();
  },
  methods: {
    async getSections() {
      try {
        const userId = localStorage.getItem("userId");
        const response = await this.$axios.get("/sections/teacher/" + userId);
        console.log("Respuesta del servidor:", response.data);
        this.sections = response.data;
        this.loaded = true;
      } catch (error) {
        console.error("Error al realizar la solicitud GET:", error);
      }
    },
    async postSection() {
      try {
        const userId = localStorage.getItem("userId");
        const response = await this.$axios.post("/sections/" + userId, this.sectionData);
        console.log("Respuesta del servidor:", response.data);
        this.getSections();
      } catch (error) {
        console.error("Error al realizar la solicitud GET:", error);
      }
    },
    goToRoute(route) {
      router.push("/" + route);
    },
    copyText(index) {
      navigator.clipboard.writeText(this.sections[index].sectionCode);
    }
  },
};
</script>

<style scoped>
.home {
  flex: 1;
  background-color: var(--not-so-grey);
}

.center-all {
  display: flex;
  align-items: center;
  justify-content: center;
}

p {
  margin: 0;
}

.container {
  width: 70%;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  background-color: #f4f8f7;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 200px;
  height: 200px;
  padding: 10px;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
}

.card-content {
  color: var(--another-grey);
  text-align: start;
}

.card-content-other {
  font-style: italic;
}

.card-add {
  align-items: center;
  justify-content: center;
}

.card-other:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}

.separate {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.separate2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.icon {
  cursor: pointer;
  padding: 8px;
  color: white;
  background-color: var(--main-color);
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.button {
  margin: 10px 0;
  width: 100%;
  background-color: var(--main-color);
  color: var(--white);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 18px;
  letter-spacing: 1.2px;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.button:hover,
.icon:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}
</style>